import { REDO_ONBOARDING_APP_URL } from "@redotech/redo-merchant-app-common/config";
import { ONBOARDING_LOCALE_PARAM } from "@redotech/redo-onboarding-api/locale-param";
import {
  ONBOARDING_RESUME_SOURCE_PARAM,
  type OnboardingResumeSource,
} from "@redotech/redo-onboarding-api/resume-source";

// First-install intake now lives in welcome/first-install/, entered via
// onboarding/first-install-redirect-guard.tsx. This module keeps only the URL builder.

/** Builds an onboarding-app URL with the merchant auth handoff in query params. */
export function autoOnboardingUrl(
  token: string,
  teamId: string,
  resumeSource?: OnboardingResumeSource,
  locale?: string,
) {
  const url = new URL(REDO_ONBOARDING_APP_URL);
  url.searchParams.set("token", token);
  url.searchParams.set("teamId", teamId);
  if (resumeSource) {
    url.searchParams.set(ONBOARDING_RESUME_SOURCE_PARAM, resumeSource);
  }
  if (locale) {
    url.searchParams.set(ONBOARDING_LOCALE_PARAM, locale);
  }
  return url;
}

/** Carries the dashboard language onto a server-built onboarding-app URL. */
export function withOnboardingLocale(
  url: string,
  locale: string | undefined,
): string {
  if (!locale) {
    return url;
  }
  const withLocale = new URL(url);
  withLocale.searchParams.set(ONBOARDING_LOCALE_PARAM, locale);
  return withLocale.toString();
}
